import Const from 'const';

class CreatedLineupsMap {
    constructor(public readonly lineupsMap: object = {}) {}
    getRegeneratedLineupIdByLateswapLineupPlayersChecksum(playersChecksum: string): string | null {
        return this.lineupsMap[playersChecksum] || null;
    }
}

const createdLineupsMap = new CreatedLineupsMap();

export default function (state = createdLineupsMap, action) {
    switch (action.type) {
        case Const.LATESWAP_SET_CREATED_LINEUPS_MAP:
            return new CreatedLineupsMap(action.data);

        case Const.FILTER_BY_SLATE:
        case Const.OPTIMIZATION_START:
            return new CreatedLineupsMap();

        default:
            return state;
    }
}
